import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { withUnitOfMeasurements } from "../Preferences/withUnitOfMeasurements";
import { setSessionPreferences } from "./../../../actions";
import { getUnitOfMeasurementsSelector } from "./../../../selectors/selectors";
import ButtonsBlock from "./ButtonsBlock";

class UnitButtons extends PureComponent {
  static propTypes = {
    changeUnits: PropTypes.func,
    isUserMetadataFetched: PropTypes.bool,
    setSessionPreferences: PropTypes.func,
    unitOfMeasurements: PropTypes.array,
    unitOfMeasurementsPreferences: PropTypes.object
  };

  static defaultProps = {
    changeUnits: null,
    unitOfMeasurements: [],
    unitOfMeasurementsPreferences: {}
  };

  componentDidMount() {
    if (!_.isEmpty(this.props.unitOfMeasurements)) {
      this.handleUnitsChange(this.props.unitOfMeasurementsPreferences);
    }
  }

  componentDidUpdate(prevProps) {
    const { unitOfMeasurements, isUserMetadataFetched } = this.props;
    const hasUserMetadataChanged = !prevProps.isUserMetadataFetched && isUserMetadataFetched;
    const hasUnitOfMeasurementsChanged = !_.isEmpty(unitOfMeasurements) && _.isEmpty(prevProps.unitOfMeasurements);

    if (
      (hasUserMetadataChanged && !_.isEmpty(unitOfMeasurements)) ||
      (hasUnitOfMeasurementsChanged && isUserMetadataFetched)
    ) {
      this.handleUnitsChange(this.props.unitOfMeasurementsPreferences);
    }
  }

  handleSelectedUnit = (unit, type) => {
    this.handleUnitsChange({ ...this.props.unitOfMeasurementsPreferences, [type]: unit });
  };

  handleUnitsChange = params => {
    this.props.setSessionPreferences({ unitOfMeasurements: params });
    this.props.changeUnits(params);
  };

  render() {
    return (
      <ButtonsBlock
        unitOfMeasurements={this.props.unitOfMeasurements}
        userUnits={this.props.unitOfMeasurementsPreferences}
        onSelectedUnit={this.handleSelectedUnit}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isUserMetadataFetched: state.app.isUserMetadataFetched,
    unitOfMeasurements: getUnitOfMeasurementsSelector(state)
  };
};

export default connect(
  mapStateToProps,
  { setSessionPreferences }
)(withUnitOfMeasurements(UnitButtons));



// WEBPACK FOOTER //
// ./src/components/Common/UnitsSelector/UnitButtons.js